import { format } from 'date-fns/esm'
import React, { FC, useCallback } from 'react'
import ReactDatePicker, { ReactDatePickerProps } from 'react-datepicker'
import SmallCalendarIcon from '../../Icons/SmallCalendar'
import CustomPopup from '../../Popup'

import './DateRangePicker.scss'

type DateRangePickerProps = {
  dates: [Date, Date]
  datePickerProps: ReactDatePickerProps
}

const DateRangePicker: FC<DateRangePickerProps> = ({ dates, datePickerProps }) => {
  const popupTriggerForDatePicker = useCallback(
    () => (
      <div className='list_datepicker-dates'>
        <SmallCalendarIcon />
        <div className='list_datepicker-date'>{dates[0] && format(dates[0], 'd LLLL yyyy')}</div>
        <div>-</div>
        <div className='list_datepicker-date'>{dates[1] && format(dates[1], 'd LLLL yyyy')}</div>
        <div className='list_datepicker-arrow'></div>
      </div>
    ),
    [dates]
  )

  return (
    <>
      <CustomPopup
        className='list_post-dropdown-actions'
        position='bottom center'
        trigger={popupTriggerForDatePicker}
        updateTrigger={popupTriggerForDatePicker}
        on='hover'
      >
        <div className='datepicker'>
          <ReactDatePicker
            {...datePickerProps}
            selected={dates[0]}
            startDate={dates[0]}
            endDate={dates[1]}
            selectsRange
            inline
          />
        </div>
      </CustomPopup>
    </>
  )
}

export default DateRangePicker
